import React, { useState, useEffect } from 'react';
import LocationFilter from './LocationFilter';

const ICONS = {
  locations: '📍',
  restaurant_credentials: '🔑',
  menus: '📋',
  menu_groups: '📁',
  menu_items: '🍽️',
  products: '📦',
  modifier_groups: '🔧',
  modifiers: '➕',
  item_modifier_groups: '🔗',
  product_taxes: '🧾',
  product_allergens: '⚠️',
  product_images: '🖼️',
  product_pricing_rules: '⏱️'
};

export default function DatabaseStats({ locationId, locationName }) {
  const [locationFilter, setLocationFilter] = useState(locationId || '');
  const [counts, setCounts] = useState([]);
  const [resolvedLocationName, setResolvedLocationName] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLocationFilter(locationId || '');
  }, [locationId]);

  useEffect(() => {
    fetchCounts();
  }, [locationFilter]);

  async function fetchCounts() {
    try {
      setLoading(true);
      setError(null);
      const query = locationFilter ? `?locationId=${locationFilter}` : '';
      const response = await fetch(`/api/stats/counts${query}`);
      if (!response.ok) throw new Error('Failed to fetch table counts');
      const data = await response.json();
      setCounts(data.counts);
      setResolvedLocationName(data.locationName);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  const totalRows = counts.reduce((sum, c) => sum + c.count, 0);

  return (
    <div className="stats-page-container">
      <h2>🗄️ Database Stats {locationFilter && resolvedLocationName ? `- ${resolvedLocationName}` : '- All Locations'}</h2>
      <p className="subtitle">Row counts across every table currently in the database</p>

      <div className="catalog-filters">
        <LocationFilter value={locationFilter} onChange={setLocationFilter} />
      </div>

      {loading && <p className="loading">Loading...</p>}
      {error && <div className="error">✕ {error}</div>}

      {!loading && !error && (
        <>
          <div className="stats-grid">
            {counts.map(c => (
              <div key={c.key} className="stat-card">
                <div className="stat-card-icon">{ICONS[c.key] || '🗂️'}</div>
                <div className="stat-card-content">
                  <h4>{c.label}</h4>
                  <div className="stat-card-value">{c.count.toLocaleString()}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="stats-total-bar">
            <span>Total rows across all tables</span>
            <strong>{totalRows.toLocaleString()}</strong>
          </div>
        </>
      )}
    </div>
  );
}
